export { AbstractLink as Link } from "~/components/abstracts/Link"
export type { AbstractLinkProps } from "~/components/abstracts/Link"
